import React from 'react'
import { LucideIcon } from 'lucide-react'
import { cn } from '@/core/infra_utils'
import { Heading, Text } from '@agion/ui'

export interface PageHeaderProps {
  title: string
  description?: string
  icon?: LucideIcon
  iconColor?: string
  actions?: React.ReactNode
  className?: string
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title, description, icon: Icon, iconColor = 'opacity-30', actions, className,
}) => (
  <div className={cn('mb-6', className)}>
    <div className="flex items-start justify-between">
      <div>
        <Heading level="h1" className="flex items-center gap-3">
          {Icon && <Icon className={cn('h-8 w-8', iconColor)} />}
          {title}
        </Heading>
        {description && <Text color="muted" className="mt-2">{description}</Text>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  </div>
)
